export default "__VITE_PUBLIC_ASSET__dc77a5a8__"